import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

import { DATE_PICKER_FORMAT } from '@/utils/constants.ts'

import { DueStatus } from '../types'

dayjs.extend(isoWeek)

export const formatMyWorkTimestamp = (
  value: string | Date | null | undefined
): string => {
  if (!value) return '--'

  try {
    const date = dayjs(value)
    if (!date.isValid()) return '--'

    return date.format('MM/DD/YYYY – hh:mm:ss A')
  } catch {
    return '--'
  }
}

export const formatMyWorkDate = (
  value: string | Date | null | undefined
): string => {
  if (!value) return '--'

  try {
    const date = dayjs(value)
    if (!date.isValid()) return '--'

    return date.format(DATE_PICKER_FORMAT)
  } catch {
    return '--'
  }
}

export const isDateInCurrentWeek = (date: string | Date): boolean => {
  try {
    const checkDate = dayjs(date)
    if (!checkDate.isValid()) return false

    const today = dayjs().startOf('day')
    const startOfWeek = today.isoWeekday(1).startOf('day')
    const endOfWeek = today.isoWeekday(7).endOf('day')

    const isInWeek =
      checkDate.isAfter(startOfWeek) && checkDate.isBefore(endOfWeek)
    const isNotToday = !checkDate.isSame(today, 'day')

    return isInWeek && isNotToday
  } catch {
    return false
  }
}

export const calculateOverdueDays = (dueDate: string | null): number | null => {
  if (!dueDate) return null

  try {
    const due = dayjs(dueDate).startOf('day')
    if (!due.isValid()) return null

    const today = dayjs().startOf('day')

    if (today.isAfter(due)) {
      return today.diff(due, 'day')
    }

    return null
  } catch {
    return null
  }
}

export const calculateDueStatus = (dueDate: string | null): DueStatus => {
  if (!dueDate) return DueStatus.NONE

  try {
    const due = dayjs(dueDate).startOf('day')
    if (!due.isValid()) return DueStatus.NONE

    const today = dayjs().startOf('day')

    if (today.isAfter(due)) {
      return DueStatus.OVERDUE
    }

    if (due.isSame(today, 'day')) {
      return DueStatus.DUE_TODAY
    }

    if (isDateInCurrentWeek(dueDate)) {
      return DueStatus.DUE_THIS_WEEK
    }

    return DueStatus.NONE
  } catch {
    return DueStatus.NONE
  }
}
